import { useState, useEffect, useCallback } from 'react';
import { convertToArgentinaTime } from '../helpers/widgetsCharts';

export const useChartData = (dataConsumption, meterSelected) => {
  const [date, setDate] = useState([]);

  const convertTime = useCallback((dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString("es-AR", {
      timeZone: "America/Argentina/Buenos_Aires",
    });
  }, []);

  useEffect(() => {
    if (meterSelected.measureType && dataConsumption) {
      setDate(dataConsumption?.map(d => convertTime(d.timestamp)));
    }
  }, [dataConsumption, meterSelected.measureType, convertTime]);

  return { date };
}; 